<template>
    <div class="logs-pages">
        <PageTitle icon="mdi-alert" main="Logs"
            sub="" />
        
        <div class="logs-pages-tabs">
            <v-tabs
            background-color="indigo"
            slider-color="indigo lighten-5"
            v-model="tabActived"
            grow
            center-active
            dark
            icons-and-text
            >
                <v-tab
                    v-for="n in nav.length"
                    :key="n"
                    ripple
                    class="ma-0"
                    >
                    {{ nav[n-1].title }}
                    <v-icon>{{ nav[n-1].icon }}</v-icon>
                </v-tab>
                <v-tab-item
                    v-for="n in nav.length"
                    :key="n">
                    <v-card flat>
                        <v-card-text>
                            <keep-alive>
                                <Register 
                                    :scope="nav[n-1].scope"
                                    :path="nav[n-1].path"
                                    :segment="nav[n-1].segment"
                                    :arrayChilds="nav[n-1].arrayChilds"
                                    :minorScopes="nav[n-1].minorScopes"
                                    :componentHeader="nav[n-1].componentHeader"
                                    :disableNewItem="nav[n-1].disableNewItem"
                                    :enableImport="nav[n-1].enableImport"
                                    :headers="nav[n-1].headers"
                                    :subHeaders="nav[n-1].subHeaders"
                                    :expand="nav[n-1].expand"
                                    :maxWidthForm="nav[n-1].maxWidthForm"
                                    :itemModel="nav[n-1].itemModel"
                                    :inputs="nav[n-1].inputs"
                                />
                            </keep-alive>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Register from '../register/Default'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('registers')

export default {
    name: 'LogPages',
    components: { PageTitle, Register },
    props: { _id: String, },
    data: function() {
        return {
            nav: [
                /* Logs */
                {
                    title: 'Logs',
                    icon: 'mdi-alert',
                    path: 'logs',
                    scope: 'logs',
                    disableNewItem: true,
                    headers: [
                        { text: 'Registro', value: 'collectionInfo.name', options: {} },
                        { text: 'Operação', value: 'operation', options: {} },
                        { text: 'Usuário', value: 'user', options: {} },
                        { text: 'Sucessos', value: 'successCount', options: {} },
                        { text: 'Erros', value: 'errorsCount', options: {} },
                        { text: 'Data', value: 'createdAt', options: { dateHour: true } },
                        { 
                            text: 'Ações', 
                            value: 'actions', 
                            sortable: false, 
                            align: 'center', 
                            options: { 
                                load: true,
                                view: false,
                                edit: false, 
                                delete: false, 
                                tdClass: 'text-center', 
                            } 
                        }
                    ],
                },
                /* Log */ 
                {
                    title: 'Log',
                    icon: 'mdi-alert',
                    scope: 'log',
                    path: 'logs',
                    segment: (typeof this._id !== 'undefined') ? this._id : 'latest',
                    arrayChilds: ['errorsList'],
                    componentHeader: true,
                    disableNewItem: true,
                    headers: [
                        { text: 'Item', value: 'item', options: {} },
                        { text: 'Erro', value: 'error', options: {} },
                    ],
                }, 
            ]
        }
    },
    computed: {
        ...mapGetters(['tabActived']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
		},
    },
}
</script>

<style>

</style>